import { useDispatch } from 'react-redux';

import { SubscriptionInputDto, SubscriptionOutputDto } from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchSubscription = (): UseFetchHookOutput<
	Omit<SubscriptionInputDto, 'metadata'>,
	SubscriptionOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<SubscriptionInputDto, SubscriptionOutputDto>({
		operationKey: 'subscription',
		withLoading: false,
		onSuccess: (res) => {
			if (res) {
				dispatch(saveSuccessServiceResponse({ subscription: res.data }));
			}
		},
	});
};
